import React from "react";
import "./index.css";
import Sidebar from "../../../../components/Sidebar";
import TableHeader from "../../../../components/TableHeader/index";
import PageHeader from "../../../../components/PageHeader";
import moment from "moment";
import Pagination from "../../../../components/Pagination";
import {checkPermission} from "../../../../utils/common";
import LinkPlus from "../../../../components/Link/LinkPlus";
import ModalDetailAdmissionsClient from "./detail/modalDetailAdmissionsClient";
import CustomerController from "../../../../services/qlts/admissions/customer-controller";
import {toast} from "react-toastify";
import CustomerGroupController from "../../../../services/qlts/admissions/customer-group-controller";
import DatePicker, {registerLocale} from "react-datepicker";
import vi from "date-fns/locale/vi";
import {createSearchParams, Link} from "react-router-dom";
import {getSchoolYear} from "../../../../utils/authority";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import QltsUserController from "../../../../services/qlts/qlts-user-controller";
import ModalCreateCustomerPayment from "./modalCreateCustomerPayment";
import ModalDeleteCustomer from "./modalDeleteCustomer";
import FilesApi from "../../../../services/resource/files-api";
import ModalUploadCustomer from "./modalUploadCustomer";
import * as XLSX from "xlsx";
import * as FileSaver from 'file-saver';
import {CustomerSourceType} from "./enums/customerSourceType";
import {CustomerStateType} from "./enums/customerStateType";
import ModalExportUploadCustomerError from "./ModalExportUploadCustomerError";
registerLocale("vi", vi);
class ClientsManagement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            listCustomerError: [],
            totalTodayItem: 0,

            childFullName: "",
            appointmentDateFrom: "",
            appointmentDateTo: "",
            createAt: "",
            customerState: "ALL",
            groupId: "",
            parentFullName: "",
            peopleInCharge: "",
            phone: "",
            schoolId: "",
            sourceCustomer: "",
            year: "",

            peopleInChargeUuid: null,
            partnerSearch: "",

            listGroupCustomer: [],
            countStates: [],
            listData: [],
            pageNumber: 0,
            pageSize: 30,
            sort: 'id',
            descending: 'DESC',
            totalItem: 0,
            listStyleStatus: {},
            header: [
                {
                    id: "id",
                    name: "STT",
                    style: {textAlign: "center"},
                    sort: true
                },
                {
                    id: "child",
                    name: "Tên con",
                    style: {textAlign: "left"},
                    sort: false
                },
                {
                    id: "birthday",
                    name: "Ngày sinh",
                    style: {textAlign: "left"},
                    sort: false
                },
                {
                    id: "name",
                    name: "Tên phụ huynh",
                    style: {textAlign: "left"},
                    sort: false
                },
                {
                    id: "phone",
                    name: "Số điện thoại",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "des",
                    name: "Nội dung quan tâm",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "currentClass",
                    name: "Lớp học",
                    style: {textAlign: "left"},
                    sort: false
                },

                {
                    id: "created_date",
                    name: "Ngày hẹn",
                    style: {textAlign: "center"},
                    sort: false
                },

                {
                    id: "support",
                    name: "Người phụ trách",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "test",
                    name: "Bài Test",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "status",
                    name: "Trạng thái",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "action",
                    name: "Thao tác",
                    style: {textAlign: "center"},
                    sort: false
                }
            ]
        };
    }
    renderStatus = (status) => {
        for (let pos in CustomerStateType){
            if (status === CustomerStateType[pos].id){
                return <h6><span className={CustomerStateType[pos].labelCss}>{CustomerStateType[pos].name}</span></h6>;
            }
        }
        return ""
    };
    renderTest = (status, point) => {
        if (status=="TESTED"){
            return <h6><span className="badge bg-success text-white">Đã Test({point})</span></h6>;
        }else if (status=="UN_TESTED"){
            return <h6><span className="badge badge-danger text-white">Chưa Test</span></h6>;
        }else {
            return <h6><span className="badge bg-success text-white">Tuyển thẳng({point})</span></h6>;
        }

    };
    renderSDT = (row) => {
        if (row.phone == null){
            return <div>
                Bố: <a href={row.parentsRes[0]?.gender==="MALE" || row.parentsRes[0]?.gender===null? "tel:"+row.parentsRes[0]?.phone: "tel:"+row.parentsRes[1]?.phone}>{row.parentsRes[0]?.gender==="MALE" || row.parentsRes[0]?.gender=== null? row.parentsRes[0]?.phone: row.parentsRes[1]?.phone}</a><br/>
                Mẹ: <a href={row.parentsRes[0]?.gender==="FEMALE"? "tel:"+row.parentsRes[0]?.phone: row.parentsRes[1]?.phone}>{row.parentsRes[0]?.gender==="FEMALE"? row.parentsRes[0]?.phone: row.parentsRes[1]?.phone}</a>
            </div>
        }else {
            return <div>
                SĐT: <a href={"tel:"+row.phone}>{row.phone}</a><br/>
                Bố: <a href={row.parentsRes[0]?.gender==="MALE" || row.parentsRes[0]?.gender===null? "tel:"+row.parentsRes[0]?.phone: "tel:"+row.parentsRes[1]?.phone}>{row.parentsRes[0]?.gender==="MALE" || row.parentsRes[0]?.gender=== null? row.parentsRes[0]?.phone: row.parentsRes[1]?.phone}</a><br/>
                Mẹ: <a href={row.parentsRes[0]?.gender==="FEMALE"? "tel:"+row.parentsRes[0]?.phone: row.parentsRes[1]?.phone}>{row.parentsRes[0]?.gender==="FEMALE"? row.parentsRes[0]?.phone: row.parentsRes[1]?.phone}</a>
            </div>
        }
       };
    componentDidMount() {
        this.setState({showLoading: true},
            () => this.getListCustomer()
        )
        this.getListGroupCustomer()
        this.initStyleStatus()
        this.updateStyleStatus()
        this.getListPeopleInCharge()
        this.onhandleToday(false)
    }
    initStyleStatus() {
        for(let i=0; i< CustomerStateType.length; i++){
            this.state.listStyleStatus[CustomerStateType[i].id] = {cursor: 'pointer', width: 35, minWidth: "fit-content", margin: 2}
        }
    }
    updateStyleStatus(){
        for(let i=0; i< CustomerStateType.length; i++){
            this.state.listStyleStatus[CustomerStateType[i].id] = {cursor: 'pointer', width: 35, minWidth: "fit-content", margin: 2}
        }
        this.state.listStyleStatus[this.state.customerState] = {cursor: 'pointer', width: 35, fontSize: 18, fontWeight: 'bold', minWidth: "fit-content"}
    }
    getSort(){
        return this.state.sort + " "+ this.state.descending
    }
    getListPeopleInCharge() {
        let payload = {
            "pageNumber": 0,
            "pageSize": 1000,
            "sort": this.getSort()
        }
        QltsUserController.getList(payload, res => {
            if (res.success) {
                if (res.data.content.length > 0){
                    this.setState({
                        listPeopleInCharge:  res.data.content
                    })
                }
            }
        });
    }
    onhandleCancel() {
        this.setState(
            {
                "childFullName": "",
                "createAt": "",
                "appointmentDateFrom": "",
                "appointmentDateTo": "",
                "customerState": "",
                "groupId": "",
                "parentFullName": "",
                "peopleInCharge": "",
                "phone": "",
                "sourceCustomer": "",
            }, () =>{
                this.getListCustomer()
            }
        )
    }
    onSearch = () => {
        let payload = {
            "childFullName":  this.state.childFullName,
            "createAt": this.state.createAt,
            "appointmentDateFrom":  moment(this.state.appointmentDateFrom).format("YYYY-MM-DD") == "Invalid date"? "":moment(this.state.appointmentDateFrom).format("YYYY-MM-DD"),
            "appointmentDateTo": moment(this.state.appointmentDateTo).format("YYYY-MM-DD") == "Invalid date"?"": moment(this.state.appointmentDateTo).format("YYYY-MM-DD"),
            "customerState": this.state.customerState,
            "groupId": parseInt(this.state.groupId),
            "pageNumber": this.state.pageNumber,
            "pageSize": this.state.pageSize,
            "parentFullName": this.state.parentFullName,
            "peopleInCharge": this.state.peopleInChargeUuid == null?"": this.state.peopleInChargeUuid,
            "phone": this.state.phone,
            "sort": this.getSort(),
            "sourceCustomer": this.state.sourceCustomer,
            yearId: parseInt(getSchoolYear()),
        };
        CustomerController.searchCustomer(payload, res => {
            if (res.success) {
                this.setState(
                    {
                        listData: res.data.content,
                        totalItem: res.data.totalElements,
                    }
                );
            } else {
            }
        });
    }
    onhandleSearch = () => {
        this.updateStyleStatus()
        if (this.state.customerState == "ALL"){
            this.onhandleCancel()
        }else {
            this.onSearch()
        }
    };
    onhandleToday(isGetData) {
        this.setState(
            {
                "childFullName": "",
                "createAt": "",
                "appointmentDateFrom": "",
                "appointmentDateTo": "",
                "customerState": "",
                "groupId": "",
                "parentFullName": "",
                "peopleInCharge": "",
                "phone": "",
                "sourceCustomer": "",
            }, () =>{
                let today = new Date()
                let lastDay = new Date(today.getFullYear(), today.getMonth(), today.getDate()-1);
                this.updateStyleStatus()
                let payload = {
                    "childFullName":  this.state.childFullName,
                    "createAt": this.state.createAt,
                    "appointmentDateFrom":  moment(lastDay).format("YYYY-MM-DD")+ " 16:59:59",
                    "appointmentDateTo": moment(today).format("YYYY-MM-DD")+ " 17:00:00",
                    "customerState": this.state.customerState,
                    "groupId": this.state.groupId,
                    "pageNumber": 0,
                    "pageSize": 1000,
                    "parentFullName": this.state.parentFullName,
                    "peopleInCharge": this.state.peopleInChargeUuid == null?"": this.state.peopleInChargeUuid,
                    "phone": this.state.phone,
                    "sort": this.getSort(),
                    "sourceCustomer": this.state.sourceCustomer,
                    yearId: parseInt(getSchoolYear()),
                };
                CustomerController.searchCustomer(payload, res => {
                    if (res.success) {
                        if (isGetData){
                            this.setState(
                                {
                                    listData: res.data.content,
                                    totalTodayItem: res.data.totalElements,
                                }
                            );
                        }else {
                            this.setState(
                                {
                                    totalTodayItem: res.data.totalElements,
                                }
                            );
                        }
                    } else {
                    }
                });
            }
        )

    }
    getListCustomer() {
        let payload = {
            pageNumber: this.state.pageNumber,
            pageSize: this.state.pageSize,
            yearId: parseInt(getSchoolYear()),
            sort: this.state.sort +" "+this.state.descending,
            state: "ALL",
        };
        CustomerController.getListCustomer(payload, res => {
            this.setState(
                {
                    showLoading: false
                }
            );
            if (res.success) {
                this.setState(
                    {
                        countStates: res.data.countStates,
                        listData: res.data.pageContent.content,
                        totalItem: res.data.pageContent.totalElements,
                    }
                );
            } else {
                toast.error("Đã xảy ra lỗi: " + res.message)
            }
        });
    }
    getNumberState(nameState){
       for (let i=0; i< this.state.countStates.length; i++){
           if (this.state.countStates[i].state === nameState){
               return this.state.countStates[i].count
           }

       }
       return 0
    }
    getListGroupCustomer() {
        let payload = {
            pageNumber: this.state.pageNumber,
            pageSize: 10,
            sort: this.getSort(),
        };
        CustomerGroupController.getCustomerGroups(payload,res => {
            this.setState(
                {
                    showLoading: false
                }
            );
            if (res.success) {
                this.setState(
                    {
                        listGroupCustomer: res.data.content
                    }
                );
            } else {
            }
        });
    }
    renderGroupCustomer = function () {
        return this.state.listGroupCustomer?.map((item, index) => <option value={item.id}>{item.name}</option>)
    };
    renderSourceCustomer = function () {
        return CustomerSourceType.map((item, index) => <option value={item.id}>{item.name}</option>)
    };
    renderCustomerStateType() {
        return CustomerStateType.map((item, index) => <button
            type="button"
            className={item.buttonCss}
            title={item.name}
            style= {this.state.listStyleStatus[item.id]}
            onClick={() => this.setState({customerState: item.id}, ()=>{
                this.onhandleSearch()
            })}
        >
            {item.name}
            <span className="noti-relation">{this.getNumberState(item.id)}</span>
        </button>)
    }
    handleChangePage = page => {
        this.setState(
            {
                pageNumber: page
            },
            () => {
                this.onhandleSearch();
            }
        );
    };
    onFileChange = () => {
        let payload = {
            file: this.state.files,
        }
        FilesApi.uploadFile(payload, res => {
            if (res.success) {
                this.setState({
                    url: res.data.url,
                }, () => {
                    toast.success('Upload khách hàng thành công!')
                })
            }
        }).catch(error => console.log("upload error>>>", error))
    };
    exportExcelFile(){
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const fileExtension = '.xlsx';
        let fileName = "SAS_Khach_Hang.xlsx"
        let payload = {
            "childFullName":  this.state.childFullName,
            "createAt": this.state.createAt,
            "appointmentDateFrom":  moment(this.state.appointmentDateFrom).format("YYYY-MM-DD") == "Invalid date"? "":moment(this.state.appointmentDateFrom).format("YYYY-MM-DD"),
            "appointmentDateTo": moment(this.state.appointmentDateTo).format("YYYY-MM-DD") == "Invalid date"?"": moment(this.state.appointmentDateTo).format("YYYY-MM-DD"),
            "customerState": this.state.customerState,
            "groupId": this.state.groupId,
            "pageNumber": 0,
            "pageSize": 1000,
            "parentFullName": this.state.parentFullName,
            "peopleInCharge": this.state.peopleInChargeUuid == null?"": this.state.peopleInChargeUuid,
            "phone": this.state.phone,
            "sort": this.getSort(),
            "sourceCustomer": this.state.sourceCustomer,
            yearId: parseInt(getSchoolYear()),
        };
        CustomerController.searchCustomer(payload, res => {
            if (res.success) {
                let dataExport = []
                for(let i=0; i< res.data.content.length; i++){
                    let studentInfo = res.data.content[i]
                    let objData = {
                        "STT" : i+1,
                        "Họ tên": studentInfo.fullName,
                        "Ngày sinh": moment(studentInfo.birthday).format("DD-MM-YYYY").toString(),
                        "Giới tính": studentInfo.gender =="MALE"? "Nam": "Nữ",
                        "SĐT": studentInfo.phone,
                        "Gmail": studentInfo.gmail,
                        "Địa chỉ": studentInfo.placeOfPermanent,
                        "Họ tên bố": studentInfo.parentsRes[0]?.fullName,
                        "Email bố": studentInfo.parentsRes[0]?.email,
                        "Họ tên mẹ": studentInfo.parentsRes[1]?.fullName,
                        "Email mẹ": studentInfo.parentsRes[1]?.email,
                        "Trường cũ": studentInfo.oldSchoolName,
                        "Điểm toán": studentInfo.testPoint,
                        "Điểm Văn": studentInfo.testPoint_1,
                        "Điểm Tiếng Anh": studentInfo.testPoint_2,
                        "Điểm môn khác": studentInfo.testPoint_3,

                    }
                    dataExport.push(objData)
                }
                const ws = XLSX.utils.json_to_sheet(dataExport);
                const wb = { Sheets: { 'TimesSchool': ws }, SheetNames: ['TimesSchool'] };
                const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
                const data = new Blob([excelBuffer], {type: fileType});
                FileSaver.saveAs(data, fileName + fileExtension);
            } else {
            }
        });
    }
    downloadFile() {
        let fileName = "SAS_Template_Import_Khach_Hang.xlsx"
        FilesApi.downloadFile(fileName, res => {
            const url = window.URL.createObjectURL(res.data);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
                "download",
                `${this.props.file.name}.${fileName}`
            );
            document.body.appendChild(link);
            link.click();

            // Clean up and remove the link
            link.parentNode.removeChild(link);
            if (res.success) {
                this.setState({
                    url: res.data.url,
                }, () => {
                    toast.success('Tải file thành công!')
                })
            }
        }).catch(error => console.log("upload error>>>", error))
    }
    checkUploadCustomer(listCustomer){
        this.setState({
            showModalUploadError: true,
            listCustomerError: listCustomer
        })
    }
    render() {
        let {listData, header} = this.state;
        return (
            <div>
                <div className="container">
                    <div className="row">
                        <Sidebar activeClass="list-customer-admissions" parentClass="admissions-management"/>
                        <div className="col-md-10 tab-content with-loading">
                            {this.state.showLoading &&
                            <div className="content-loading col-12 ml-3 align-items-center"
                                 style={{display: 'block'}}>
                                <div className="spinner-grow text-info"/>
                            </div>
                            }
                            {checkPermission("QLTS_CUSTOMER_SEARCH") &&
                                <div className="card col-12">
                                <div className="pt-3 mb-2">
                                    <PageHeader routerEnable={true} title="Quản lý khách hàng tuyển sinh"/>
                                    <form className="mt-4 kt-form kt-form--fit kt-margin-b-20">
                                        <div className="row">
                                            <div className="col-xs-12 col-sm-12 col-md-4 p-0 pr-md-3 d-flex mb-1">
                                                <label className="label-item col-md-4">Nhóm khách hàng</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.groupId}
                                                    onChange={(e) => {
                                                        this.state.groupId = e.target.value;
                                                        this.setState({
                                                            groupId: e.target.value
                                                        }, ()=>{
                                                            this.onSearch()
                                                        })
                                                    }}
                                                >
                                                    <option value="">Tất cả</option>
                                                    {this.renderGroupCustomer()}
                                                </select>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-4 p-0 pr-md-3 d-flex mb-1" >
                                                <label className="label-item col-md-4">Người phụ trách</label>
                                                <Autocomplete
                                                    size="small"
                                                    options={this.state.listPeopleInCharge}
                                                    getOptionLabel={option => option.fullName?option.fullName:"No Name"}
                                                    style={{width: '100%'}}
                                                    inputValue={this.state.partnerSearch}
                                                    renderInput={params => {
                                                        return <TextField
                                                            placeholder='Người phụ trách'
                                                            {...params}
                                                            InputLabelProps={{
                                                                shrink: true,
                                                                style: {
                                                                    fontSize: 17,
                                                                    backgroundColor: "#FFF",
                                                                    paddingRight: 10,
                                                                    paddingLeft: 10,
                                                                    color: '#2e495c',
                                                                    fontWeight: 500,
                                                                    fontFamily: 'Montserrat'
                                                                }
                                                            }}
                                                            label=""
                                                            variant="outlined"
                                                            fullWidth
                                                        />
                                                    }}
                                                    onInputChange={(event, val) => {
                                                        if (event !== null)
                                                            this.setState({
                                                                partnerSearch: val
                                                            })
                                                    }}
                                                    onChange={(e, val) => {
                                                        if (val?.uuid != undefined){
                                                            this.state.peopleInChargeUuid = val?.uuid;
                                                            this.state.partnerSearch = val?.fullName;
                                                        }else {
                                                            this.state.peopleInChargeUuid = "";
                                                        }
                                                        // this.getListPeopleInCharge()
                                                    }}

                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-4 p-0 pr-md-3 d-flex mb-1">
                                                <label className="label-item col-md-4">Nguồn khách hàng</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.sourceCustomer}
                                                    onChange={(e) => {
                                                        this.state.sourceCustomer = e.target.value;
                                                        this.setState({
                                                            sourceCustomer: e.target.value
                                                        }, ()=>{
                                                            this.onSearch()
                                                        })
                                                    }}
                                                >
                                                    <option value="">Chọn nguồn khách hàng</option>
                                                    {this.renderSourceCustomer()}
                                                </select>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-4 p-0 pr-md-3 d-flex mb-1">
                                                <label className="label-item col-md-4">Tên phụ huynh</label>
                                                <input
                                                    placeholder="Tên phụ huynh"
                                                    name="parentFullName"
                                                    type="text"
                                                    className="form-control shadow-none font-14"
                                                    style={{width: "100%", height: 35, padding: 8}}
                                                    value={this.state.parentFullName}
                                                    maxLength={50}
                                                    onKeyPress={(e) => {
                                                        if (e.key === 'Enter') {
                                                            this.onhandleSearch()
                                                        }
                                                    }}
                                                    onChange={val =>
                                                        this.setState({parentFullName: val.target.value.trim()})
                                                    }
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-4 p-0 pr-md-3 d-flex mb-1">
                                                <label className="label-item col-md-4">Tên con</label>
                                                <input
                                                    placeholder="Tên con"
                                                    name="childFullName"
                                                    type="text"
                                                    className="form-control shadow-none font-14"
                                                    style={{width: "100%", height: 35, padding: 8}}
                                                    value={this.state.childFullName}
                                                    maxLength={50}
                                                    onKeyPress={(e) => {
                                                        if (e.key === 'Enter') {
                                                            this.onhandleSearch()
                                                        }
                                                    }}
                                                    onChange={val =>
                                                        this.setState({childFullName: val.target.value})
                                                    }
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-4 p-0 pr-md-3 d-flex mb-1">
                                                <label className="label-item col-md-4">Số điện thoại</label>
                                                <input
                                                    placeholder="SĐT"
                                                    name="Code"
                                                    type="text"
                                                    className="form-control shadow-none font-14"
                                                    style={{width: "100%", height: 35, padding: 8}}
                                                    value={this.state.phone}
                                                    maxLength={50}
                                                    onKeyPress={(e) => {
                                                        if (e.key === 'Enter') {
                                                            this.onhandleSearch()
                                                        }
                                                    }}
                                                    onChange={val =>
                                                        this.setState({phone: val.target.value.trim()})
                                                    }
                                                />
                                            </div>

                                            <div className="col-xs-12 col-sm-12 col-md-4 p-0 pr-md-3 d-flex mb-1">
                                                <label className="label-item col-md-4">Ngày hẹn từ</label>
                                                <DatePicker
                                                    placeholderText="Ngày-Tháng-Năm"
                                                    locale="vi"
                                                    className="w-auto  form-control kt-input pd-4-input hei-input"
                                                    selected={this.state.appointmentDateFrom === '' ? null : new Date(this.state.appointmentDateFrom)}
                                                    dateFormat="dd-MM-yyyy"
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    onChange={
                                                        (date) => {
                                                            let value = moment(date).format("YYYY-MM-DD").toString();
                                                            try {
                                                                this.setState({
                                                                    appointmentDateFrom: value == "Invalid date" ? null : moment(value).format("YYYY-MM-DD"),
                                                                })
                                                            }catch (e) {

                                                            }
                                                        }
                                                    }
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-4 p-0 pr-md-3 d-flex mb-1">
                                                <label className="label-item col-md-4">Tới ngày</label>
                                                <DatePicker
                                                    locale="vi"
                                                    placeholderText="Ngày-Tháng-Năm"
                                                    className="w-auto  form-control kt-input pd-4-input hei-input"
                                                    selected={this.state.appointmentDateTo === '' ? null : new Date(this.state.appointmentDateTo)}
                                                    dateFormat="dd-MM-yyyy"
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    onChange={
                                                        (date) => {
                                                            let value = moment(date).format("YYYY-MM-DD").toString();
                                                            try {
                                                                this.setState({
                                                                    appointmentDateTo: value == "Invalid date" ? null : moment(value).format("YYYY-MM-DD"),
                                                                })
                                                            }catch (e) {

                                                            }
                                                        }
                                                    }
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-4 p-0 pr-md-3 d-flex mb-1">
                                                <label className="label-item col-md-4">Ngày tạo</label>
                                                <DatePicker
                                                    locale="vi"
                                                    placeholderText="Ngày-Tháng-Năm"
                                                    className="w-auto  form-control kt-input pd-4-input hei-input"
                                                    selected={this.state.createAt === '' ? null : new Date(this.state.createAt)}
                                                    maxDate={new Date()}
                                                    dateFormat="dd-MM-yyyy"
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    onChange={
                                                        (date) => {
                                                            let value = moment(date).format("YYYY-MM-DD").toString();
                                                            try {
                                                                this.setState({
                                                                    createAt: value == "Invalid date" ? null : moment(value).format("YYYY-MM-DD"),
                                                                })
                                                            }catch (e) {

                                                            }
                                                        }
                                                    }
                                                />
                                            </div>
                                            <div className="d-flex align-right col-md-12 col-xs-12 row">
                                                <div className="d-flex justify-content-center align-center mt-3 mb-2 col-md-12 col-xs-12">
                                                    <button
                                                        style={{minWidth: "fit-content", marginRight: "10px", height: 35}}
                                                        type="button"
                                                        className="border-1-s background-btn w-40 type-button-fix btn btn-primary"
                                                        onClick={() => this.onSearch()}
                                                    >
                                                    <span className='justify-content-center'>
                                                        Tìm kiếm
                                                    </span>
                                                    </button>
                                                    <button
                                                        style={{minWidth: "fit-content", height: 35}}
                                                        type="button"
                                                        className="border-1-s w-40 type-button-fix btn btn-secondary"
                                                        onClick={() => this.onhandleCancel()}
                                                    >
                                                        <span className=''>
                                                            Refresh
                                                        </span>
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-12 pr-md-3 d-flex" style={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "left"
                                            }}>
                                                <button
                                                    type="button"
                                                    className="border-1-s ml-2 mr-2 background-btn type-button-fix btn btn-primary btn-sm shadow-none position"
                                                    title='Lịch hẹn hôm nay'
                                                    onClick={() => this.onhandleToday(true)}
                                                >
                                                    Lịch hẹn hôm nay
                                                    <span className="noti-relation">{this.state.totalTodayItem}</span>
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div className="col-md-12 col-xs-12 col-sm-3 col-12 p-0 pr-md-3 d-flex row mb-2">
                                    <button
                                        type="button"
                                        className="btn bg-secondary text-white position-relative mr-2"
                                        title='Tất cả'
                                        style= {this.state.listStyleStatus["ALL"]}
                                        onClick={() => this.setState({customerState: "ALL"}, ()=>{
                                            this.onhandleSearch()
                                        })}
                                    >
                                        Tất cả
                                        <span
                                            className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                                                            {this.getNumberState("ALL")}
                                                            <span className="visually-hidden"></span>
                                                          </span>
                                    </button>
                                    {this.renderCustomerStateType()}
                                    <div className="col-md-12 col-xs-12 col-12 mt-1 mb-1 p-0 pr-md-3 d-flex row"
                                         style={{
                                             alignItems: "center",
                                             justifyContent: "right"
                                         }}>
                                        {checkPermission("QLTS_CUSTOMER_ADD") &&
                                            <LinkPlus
                                                to="/ad-sas-school/admissions/danh-sach-khach-hang/them-moi"
                                            >
                                                <button
                                                    type="button"
                                                    className="border-1-s mr-2 background-btn type-button-fix btn btn-primary btn-sm shadow-none"
                                                    title='Thêm mới'
                                                    style={{cursor: 'pointer'}}
                                                >
                                                    Thêm mới
                                                </button>
                                            </LinkPlus>
                                        }

                                        {checkPermission("QLTS_CUSTOMER_ADD") &&
                                        <LinkPlus
                                            to="#"
                                        >
                                            <button
                                                type="button"
                                                className="border-1-s mr-2 background-btn type-button-fix btn btn-info btn-sm shadow-none"
                                                title='Tải file mẫu'
                                                onClick={() => this.downloadFile()}
                                                style={{cursor: 'pointer'}}
                                            >
                                                <i className="ti-cloud-down"/> Tải file mẫu
                                            </button>
                                        </LinkPlus>
                                        }
                                        {checkPermission("QLTS_CUSTOMER_ADD") &&
                                        <LinkPlus
                                            to="#"
                                        >
                                            <button
                                                type="button"
                                                className="border-1-s mt-1 mr-2 background-btn type-button-fix btn btn-info btn-sm shadow-none"
                                                title='Thêm mới'
                                                onClick={() => this.setState({showModalUpload: true})}
                                                style={{cursor: 'pointer'}}
                                            >
                                                Import khách hàng
                                            </button>
                                        </LinkPlus>
                                        }
                                        <LinkPlus
                                            to="#"
                                        >
                                        <button
                                            type="button"
                                            className="border-1-s mr-2 background-btn type-button-fix btn btn-secondary btn-sm shadow-none"
                                            title='Tải file mẫu'
                                            onClick={() => this.exportExcelFile()}
                                            style={{cursor: 'pointer'}}
                                        >
                                            <i className="ti-export"/> Export Excell
                                        </button>
                                        </LinkPlus>
                                    </div>
                                </div>
                                <div className="p-0 mb-3">
                                    <div className="table-wrapper">
                                        <table
                                            className="table table-striped table-data table-responsive table-bordered">
                                            <table className="table">
                                                <thead>
                                                <TableHeader
                                                    header={header}
                                                    clickSort={data => {
                                                        let a = "";
                                                        let descend = "";
                                                        if (data.sortAsc == null) {
                                                            // a = "id=asc";
                                                            a = "id";
                                                            descend = 'DESC'
                                                        } else {
                                                            a = data.sortId;
                                                            descend = data.sortAsc ? 'ASC' : 'DESC'
                                                        }
                                                        this.setState(
                                                            {
                                                                sort: a,
                                                                descending: descend
                                                            },
                                                            () => this.getListCustomer()
                                                        );
                                                    }}
                                                />
                                                </thead>
                                                {!this.state.listData ||
                                                this.state.listData.length == 0 ? (
                                                    <tbody>
                                                    <tr>
                                                        <td colSpan={12}>
                                                            <div className="text-center">
                                                                Không có dữ liệu
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                ) : (
                                                    <tbody>
                                                    {listData &&
                                                    listData.length > 0 &&
                                                    listData?.map((row, index) => (
                                                        <tr style={{height: 50}}>
                                                            <td style={{textAlign: "center"}} scope="row">
                                                                {" "}
                                                                {this.state.pageNumber * this.state.pageSize +
                                                                index +
                                                                1}
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                                {row.fullName} {(row.note !== null) && <div>({row.note})</div> }
                                                            </td>
                                                            <td style={{textAlign: "left"}}>
                                                                {row.birthday == null ? "Chưa có" : moment(row.birthday).format("DD-MM-YYYY")}
                                                            </td>
                                                            <td style={{textAlign: "left"}} scope="row">
                                                                Bố: {row.parentsRes[0]?.gender==="MALE" || row.parentsRes[0]?.gender=== null? row.parentsRes[0]?.fullName: row.parentsRes[1]?.fullName}<br/>
                                                                Mẹ: {row.parentsRes[0]?.gender==="FEMALE"? row.parentsRes[0]?.fullName: row.parentsRes[1]?.fullName}
                                                            </td>
                                                            <td style={{textAlign: "left"}} scope="row">
                                                                {this.renderSDT(row)}
                                                            </td>
                                                            <td style={{textAlign: "left"}}>
                                                                {row.interestedContent}
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                                {row.currentClass}
                                                            </td>
                                                            <td style={{textAlign: "left"}}>
                                                                {row.appointmentDate == null ? "Chưa hẹn" : moment(row.appointmentDate).format("DD-MM-YYYY")}
                                                            </td>

                                                            <td style={{textAlign: "left"}}>
                                                                {row.peopleInChargeRes?.fullName}
                                                            </td>
                                                            <td style={{textAlign: "left"}}>
                                                                {this.renderTest(row.testState, row.testPoint)}
                                                            </td>
                                                            <td style={{textAlign: "left"}}>
                                                                {this.renderStatus(row.customerState)}
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                                <button className="btn btn-action p-2"
                                                                        title='Chi tiết'
                                                                        style={{cursor: 'pointer'}}
                                                                        onClick={() => {
                                                                            this.setState({itemSelected: row.id, showModalDetail: true})
                                                                        }}
                                                                >
                                                                    <i className="ti-book"/>
                                                                </button>
                                                                {checkPermission("QLTS_CUSTOMER_EDIT") &&
                                                                    <LinkPlus
                                                                        to={{
                                                                            pathname: "/ad-sas-school/admissions/danh-sach-khach-hang/sua",
                                                                            search: createSearchParams({
                                                                                id: `${row.id}`
                                                                            }).toString(),
                                                                            state: {
                                                                                fromDashboard: true,
                                                                                id: row.id
                                                                            }
                                                                        }}
                                                                    >
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-action p-2"
                                                                            title='Chỉnh sửa'
                                                                            style={{cursor: 'pointer'}}
                                                                        >
                                                                            <i className="ti-pencil-alt"/>
                                                                        </button>
                                                                    </LinkPlus>
                                                                }
                                                                {checkPermission("QLTS_CUSTOMER_DELETE") &&
                                                                    <button className="btn btn-action p-2"
                                                                            title='Xóa'
                                                                            style={{cursor: 'pointer'}}
                                                                            onClick={() => {
                                                                                this.setState({itemSelected: row.id, showModalDelete: true})
                                                                            }}
                                                                    >
                                                                        <i className="ti-trash"/>
                                                                    </button>
                                                                }
                                                                {(row.customerState == "BOOKED" || row.customerState == "PROFILED")&&
                                                                    <button className="btn btn-action p-2"
                                                                        title='Nộp tiền'
                                                                        style={{cursor: 'pointer'}}
                                                                        onClick={() => {
                                                                            this.setState({itemSelected: {
                                                                                    customerId: row.id,
                                                                                    childName: row.fullName
                                                                                }, showModalCustomerPayment: true})
                                                                        }}
                                                                >
                                                                    <i className="ti-money"/>
                                                                </button>
                                                                }
                                                            </td>
                                                        </tr>
                                                    ))}
                                                    </tbody>
                                                )}
                                            </table>
                                        </table>
                                    </div>
                                    <div className="pagination-right">
                                        <Pagination
                                            activePage={this.state.pageNumber}
                                            itemsCountPerPage={this.state.pageSize}
                                            totalItemsCount={this.state.totalItem}
                                            changeHandler={page => this.handleChangePage(page)}
                                        />
                                    </div>
                                </div>
                            </div>
                            }
                        </div>
                    </div>
                </div>
                <ModalDetailAdmissionsClient
                    show={this.state.showModalDetail}
                    onHide={() => this.setState({showModalDetail: false})}
                    onRefresh={() => this.getListCustomer()}
                    id={this.state.itemSelected}
                />
                <ModalCreateCustomerPayment
                    show={this.state.showModalCustomerPayment}
                    onHide={() => this.setState({showModalCustomerPayment: false})}
                    onRefresh={() => {}}
                    info={this.state.itemSelected}
                />
                <ModalDeleteCustomer
                    show={this.state.showModalDelete}
                    onHide={() => this.setState({showModalDelete: false})}
                    onRefresh={() => this.getListCustomer()}
                    id={this.state.itemSelected}
                />
                <ModalUploadCustomer
                    show={this.state.showModalUpload}
                    showLoading={() => this.setState({showLoading: true})}
                    onHide={() => this.setState({showModalUpload: false})}
                    onRefresh={() => this.getListCustomer()}
                    showCustomerError={(listCustomerError) => this.checkUploadCustomer(listCustomerError)}
                    id={this.state.itemSelected}
                />
                <ModalExportUploadCustomerError
                    show={this.state.showModalUploadError}
                    onHide={() => this.setState({showModalUploadError: false})}
                    onRefresh={() => this.getListCustomer()}
                    listCustomerError={this.state.listCustomerError}
                />
            </div>
        );
    }
}
export default ClientsManagement;
